import offsetImg2 from "../../assets/img/StandardPrintingPack.png";
import offsetImg3 from "../../assets/img/StandardWedingPack.png";
import offsetImg1 from "../../assets/img/FuneralStandard.png";

export const standardPacksLinks = [
    {
        title: "Standard Birthday Bundle",
        description: "Helps you manage all your printing needs on an AVERAGE BUDGET. Click bellow to see what is contained in this pack and order now.",
        imgUrl: offsetImg2,
        link: "https://selar.co/ece6",
    },
    {
        title: "Standard Wedding Bundle",
        description: "Helps you manage all your printing needs on an AVERAGE BUDGET. Click bellow to see what is contained in this pack and order now.",
        imgUrl: offsetImg3,
        link: "https://selar.co/6oeu",
    },
    {
        title: "Standard Funeral Bundle",
        description: "Helps you manage all your printing needs on an AVERAGE BUDGET. Click bellow to see what is contained in this pack and order now.",
        imgUrl: offsetImg1,
        link: "https://selar.co/zb7b",
    },    
    
  ];